import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import "./index.css";

createRoot(document.getElementById("root")!).render(<App />);

// Sentinel for the build-time prerender (scripts/prerender-html.ts).
// Puppeteer waits for [data-prerender-ready] before snapshotting the DOM,
// ensuring localized React content has hydrated.
if (typeof window !== "undefined") {
  const markReady = () => {
    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        document.documentElement.setAttribute("data-prerender-ready", "1");
      });
    });
  };
  if (document.readyState === "complete") {
    markReady();
  } else {
    window.addEventListener("load", markReady, { once: true });
  }
}
